import React, { useCallback, useState } from "react";
import {
  IconCalendar,
  IconCaretRight,
  IconCaretDown,
  IconQuestionMark,
  IconStar,
  IconStarFilled,
} from "@tabler/icons-react";
import { Text, Title, ActionIcon, Flex } from "@mantine/core";

import { CustomQuestionForm, Assigner } from "@legacy/Questions";

import { ENGAGEMENT_VALUE } from "@util/data/surveyVariety";

function VersionItem({
  id,
  active,
  name,
  number,
  createdAt,
  questionCount,
  onActiveClick,
  addDisabled = false,
  assignerDisabled = false,
  orderingDisabled = false,
  removeDisabled = false,
  surveyVariety = "",
}) {
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const toggleOpen = useCallback(() => {
    setOpen((o) => !o);
  }, []);

  const bumpRefresh = useCallback(() => {
    setRefresh((r) => !r);
  }, []);

  return (
    <div className="version-item">
      <Flex align="center" gap="md">
        <ActionIcon variant="light" size="lg" onClick={toggleOpen}>
          {open ? <IconCaretDown size={24} /> : <IconCaretRight size={24} />}
        </ActionIcon>
        <div style={{ flexGrow: 1 }}>
          <Title order={4}>
            Version {number} {name ? `(${name})` : ""}
          </Title>
          <Text size="sm">{createdAt}</Text>
          <Text size="sm">{questionCount} questions</Text>
        </div>
        <ActionIcon
          radius="xl"
          variant="light"
          size="lg"
          onClick={() => (!active ? onActiveClick() : null)}
          color={active ? "yellow" : "gray"}
        >
          {active ? <IconStarFilled size={18} /> : <IconStar size={18} />}
        </ActionIcon>
      </Flex>
      {open && (
        <div className="version-details">
          {surveyVariety === ENGAGEMENT_VALUE && (
            <div style={{ marginBottom: "15px" }}>
              <CustomQuestionForm
                position={questionCount}
                versionId={id}
                onUpdate={bumpRefresh}
              />
            </div>
          )}
          <Assigner
            refresh={refresh}
            disabled={assignerDisabled}
            versionId={id}
          />
        </div>
      )}
    </div>
  );
}

// VersionItem.propTypes = {
//   id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//   active: PropTypes.bool.isRequired,
//   name: PropTypes.string,
//   number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//   createdAt: PropTypes.string.isRequired,
//   questionCount: PropTypes.number.isRequired,
//   onActiveClick: PropTypes.func.isRequired,
//   addDisabled: PropTypes.bool,
//   assignerDisabled: PropTypes.bool,
//   orderingDisabled: PropTypes.bool,
//   removeDisabled: PropTypes.bool,
//   surveyVariety: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
// };

export default VersionItem;
